import script from "./RatingTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingTable.vue?vue&type=script&setup=true&lang=js"

import "./RatingTable.vue?vue&type=style&index=0&id=c1dc89e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1dc89e0"]])

export default __exports__